import { rem } from "polished";
import styled, { css } from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/use-color";

export const CenteredHeader = styled.div`
  margin-bottom: ${rem(28)};

  .text-primitive.headingTwo {
    text-align: center;
    color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
    margin-bottom: unset;
  }
`;

export const Embla = withViewportStyle("div")`
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-areas:
    "left-panel slides right-panel"
    ". dot-nav .";

  ${(props) => props.$viewport.mobile`
    grid-template-columns: 1fr;
    grid-template-areas:
      "slides"
      "dot-nav";
  `}
`;

export const EmblaViewport = styled.div`
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
  grid-area: slides;
  border-radius: 12px;
`;

export const EmblaContainer = styled.div`
  display: flex;
`;

export const EmblaSlide = styled.div`
  flex: 0 0 100%;
  min-width: 0;
  user-select: none;
`;

export const EventsSlide = withViewportStyle("div")`
  display: flex;
  height: 100%;

  > * {
    margin: 0 12px;
  }


  ${(props) => props.$viewport.tablet`
    flex-direction: column;
    gap: 24px;
  `}
`;

export const SidePanelLeft = withViewportStyle("div")`
  grid-area: left-panel;
  align-content: center;
  margin-right: ${rem(12)};

    ${(props) => props.$viewport.mobile`
    display: none;
  `}
`;

export const SidePanelRight = withViewportStyle("div")`
  grid-area: right-panel;
  align-content: center;
  margin-left: ${rem(12)};

  
  ${(props) => props.$viewport.mobile`
    display: none;
  `}

`;

export const Dotcontainer = styled.div<{ hasMultiPages: boolean }>`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top: 28px;

  * + * {
    margin-left: 16px;
  }

  grid-area: dot-nav;

  ${({ hasMultiPages }) =>
    !hasMultiPages &&
    css`
      display: none;
    `}
`;
